if (!customElements.get('bundle-upsell')) {
  customElements.define(
    'bundle-upsell',
    class BundleUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onStepperClick.bind(this));
        this.attachToForm();
      }

      // Hook into the product page's native add-to-cart form so the standard
      // "Add to cart" button also adds the selected accessories.
      attachToForm() {
        const form = this.dataset.productFormId && document.getElementById(this.dataset.productFormId);
        if (form) {
          this.form = form;
          // Capture phase so this runs before Dawn's own submit handler.
          form.addEventListener('submit', this.onFormSubmit.bind(this), true);
        } else if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.attachToForm(), { once: true });
        }
      }

      onStepperClick(event) {
        const stepButton = event.target.closest('.bundle-upsell__qty-btn');
        if (!stepButton) return;
        event.preventDefault();

        const row = stepButton.closest('.bundle-upsell__item');
        const input = row.querySelector('.bundle-upsell__qty-input');
        let value = parseInt(input.value, 10) || 1;
        value += stepButton.dataset.qtyAction === 'plus' ? 1 : -1;
        if (value < 1) value = 1;
        input.value = value;

        // Changing the quantity implies the shopper wants this item
        const checkbox = row.querySelector('.bundle-upsell__checkbox');
        if (checkbox && !checkbox.disabled) checkbox.checked = true;
      }

      getSelectedItems() {
        const items = [];
        this.querySelectorAll('.bundle-upsell__item').forEach((row) => {
          const checkbox = row.querySelector('.bundle-upsell__checkbox');
          if (!checkbox || !checkbox.checked) return;
          const id = Number(checkbox.dataset.variantId);
          if (!id) return;
          const input = row.querySelector('.bundle-upsell__qty-input');
          let quantity = input ? parseInt(input.value, 10) : 1;
          if (!quantity || quantity < 1) quantity = 1;
          items.push({ id, quantity });
        });
        return items;
      }

      onFormSubmit(event) {
        // Second pass: let Dawn's native handler run (adds the main product and
        // refreshes the cart), then stop intercepting.
        if (this.passthrough) {
          this.passthrough = false;
          return;
        }

        const items = this.getSelectedItems();
        if (items.length === 0) return; // nothing selected → normal flow

        event.preventDefault();
        event.stopImmediatePropagation();

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .catch(() => {})
          .finally(() => this.resubmit());
      }

      // Re-trigger the form so Dawn adds the main product and renders the cart
      // notification/drawer with the accessories already included.
      resubmit() {
        this.passthrough = true;
        const submitButton = this.form.querySelector('[type="submit"]');
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit(submitButton);
        } else {
          this.form.submit();
        }
      }
    }
  );
}
